import styled from 'styled-components';
import { ThemeColours } from '../../../../../common/styles/ThemeColours';
import { FontWeight, LINK_STYLE, PRESSABLE } from '../../../../../common/styles/constants';
import { onMobile } from '../../../../../common/styles/onMobile';
import { DRAWER_WIDTH } from '../../../overlay/Drawer';
import { FilterSummary } from '../FilterSummary';

export const DrawerContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  width: ${DRAWER_WIDTH}px;
`;

export const TitleBarContainer = styled.div`
  align-items: center;
  background-color: white;
  border-bottom: 1px solid ${ThemeColours.mono200};
  box-sizing: border-box;
  display: flex;
  height: 64px;
  justify-content: space-between;
  padding: 0 64px;
  position: fixed;
  width: ${DRAWER_WIDTH}px;

  ${onMobile} {
    padding: 0 32px;
    width: 100%;
  }
`;

export const Title = styled.span`
  color: ${ThemeColours.black};
  font-size: 24px;
  font-weight: ${FontWeight.SEMI_BOLD};

  ${onMobile} {
    font-size: 16px;
  }
`;

export const Link = styled.span`
  ${LINK_STYLE}
  ${PRESSABLE}
`;

export const StyledFilterSummary = styled(FilterSummary)`
  margin: 14px 0 24px;
`;

export const FilterContainer = styled.div`
  margin: 70px 64px 0;

  ${onMobile} {
    margin: 70px 32px 0;
  }
`;

export const Spacer = styled.div`
  border-bottom: 1px solid ${ThemeColours.mono200};
`;
